import React, { memo, useContext, useEffect, useState } from "react";
import SocketContext from "../../../../context/SocketContext";
const fmt = require("indian-number-format");

function BidAskTable({ symbol }) {
  const socket = useContext(SocketContext);

  const [book, setBook] = useState([
    { bid: null, bidQty: null, ask: null, askQty: null },
    { bid: null, bidQty: null, ask: null, askQty: null },
    { bid: null, bidQty: null, ask: null, askQty: null },
    { bid: null, bidQty: null, ask: null, askQty: null },
    { bid: null, bidQty: null, ask: null, askQty: null }
  ]);

  const [total_Buy, setTotal_Buy] = useState(null);
  const [total_Sell, setTotal_Sell] = useState(null);

  useEffect(() => {
    if (!socket || !symbol?.symbol_id) return;

    socket.emit("giverate", symbol.symbol_id);

    const tradeListener = (d) => {
      setBook((prev) => [
        {
          bid: d.Bid ?? prev[0].bid,
          bidQty: d.BidQty ?? prev[0].bidQty,
          ask: d.Ask ?? prev[0].ask,
          askQty: d.AskQty ?? prev[0].askQty,
        },
        {
          bid: d.Bid1 ?? prev[1].bid,
          bidQty: d.BidQty1 ?? prev[1].bidQty,
          ask: d.Ask1 ?? prev[1].ask,
          askQty: d.AskQty1 ?? prev[1].askQty,
        },
        {
          bid: d.Bid2 ?? prev[2].bid,
          bidQty: d.BidQty2 ?? prev[2].bidQty,
          ask: d.Ask2 ?? prev[2].ask,
          askQty: d.AskQty2 ?? prev[2].askQty,
        },
        {
          bid: d.Bid3 ?? prev[3].bid,
          bidQty: d.BidQty3 ?? prev[3].bidQty,
          ask: d.Ask3 ?? prev[3].ask,
          askQty: d.AskQty3 ?? prev[3].askQty,
        },
        {
          bid: d.Bid4 ?? prev[4].bid,
          bidQty: d.BidQty4 ?? prev[4].bidQty,
          ask: d.Ask4 ?? prev[4].ask,
          askQty: d.AskQty4 ?? prev[4].askQty,
        },
      ]);

      setTotal_Buy(d.Total_Buy ?? total_Buy);
      setTotal_Sell(d.Total_Sell ?? total_Sell);
    };

    socket.on(`trade${symbol.symbol_id}`, tradeListener);
    return () => socket.off(`trade${symbol.symbol_id}`, tradeListener);
  }, [socket, symbol, total_Buy, total_Sell]);

  return (
    <div className="bg-[var(--background)] rounded-md px-3 py-3 text-[13px] font-medium text-[var(--text)] tracking-tight">
      {/* HEADER */}
      <div className="flex items-center mb-2 pb-2 border-b-2 border-[var(--hover)] text-[var(--text)]">
        <div className="flex-1 text-left">Bid</div>
        <div className="w-12 text-center">Qty</div>
        <div className="w-1" />
        <div className="flex-1 text-right">Ask</div>
        <div className="w-12 text-center">Qty</div>
      </div>

      {book.map((x, i) => (
        <Row
          key={i}
          bid={fmt.format(x.bid)}
          ask={fmt.format(x.ask)}
          bidQty={x.bidQty}
          askQty={x.askQty}
        />
      ))}

      {/* TOTAL FOOTER */}
      <div className="flex items-center mt-2 pt-2 border-t-2 border-[var(--hover)] text-[var(--text)]">
        <div className="flex-1 text-left text-[var(--buymeta)]">Total</div>
        <div className="w-12 text-center text-[var(--buymeta)]">{fmt.format(total_Buy) || "--"}</div>
        <div className="w-1" />
        <div className="flex-1 text-right text-[var(--sellmeta)]">Total</div>
        <div className="w-12 text-center text-[var(--sellmeta)]">{fmt.format(total_Sell) || "--"}</div>
      </div>
    </div>
  );
}

const Row = memo(({ bid, ask, bidQty, askQty }) => (
  <div className="flex items-center py-[2px] transition">
    <div className={`flex-1 text-left ${bid ? "text-[var(--buymeta)]" : "text-[var(--text)]"}`}>
      {bid ?? "--"}
    </div>
    <div className={`w-12 text-center ${bidQty ? "text-[var(--buymeta)]/90" : "text-[var(--text)]"}`}>
      {bidQty ?? "--"}
    </div>

    <div className="w-1 h-4 bg-[#408bff]" />

    <div className={`flex-1 text-right ${ask ? "text-[var(--sellmeta)]" : "text-[var(--text)]"}`}>
      {ask ?? "--"}
    </div>
    <div className={`w-12 text-center ${askQty ? "text-[var(--sellmeta)]/90" : "text-[var(--text)]"}`}>
      {askQty ?? "--"}
    </div>
  </div>
));

export default memo(BidAskTable);
